import { useContext, useMemo } from 'react';

import { Separator, Tooltip } from '@smartshell/ui-kit';
import { Column, Row } from 'react-table';

import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';

import { ICombosResponse } from './interfaces';
import s from './ShopCombosTable.module.scss';

export const useColumns = (): Array<
  Column<ICombosResponse['comboList'][0]>
> => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: { currency },
    },
  } = useContext(SettingsContext);

  function formatDuration(durationInSeconds: number): string {
    const hours = durationInSeconds / 3600;
    return Number.isInteger(hours) ? String(hours) : hours.toFixed(2);
  }

  return useMemo(
    () => [
      {
        Header: t('title'),
        accessor: 'title',
        Cell: ({ row }: { row: Row<ICombosResponse['comboList'][0]> }) => (
          <Tooltip
            position="left-top"
            contentClassName={s.tooltip}
            header={row.original.title}
            content={
              <div className={s.tooltip_content}>
                <Separator />
                {row.original.items.map((item) => (
                  <div key={item.entity.id} className={s.tooltip_block}>
                    <span className={s.title}>{item.entity.title}</span>
                    <span className={s.count}>
                      {item.amount} {t('pcs')}.
                    </span>
                  </div>
                ))}
                {row.original.tariff && (
                  <div className={s.tooltip_block}>
                    <span className={s.title}>{row.original.tariff.title}</span>
                    <span className={s.count}>
                      <span>
                        {formatDuration(row.original.tariff.duration)}
                      </span>{' '}
                      {t('hour')}
                    </span>
                  </div>
                )}
              </div>
            }
          >
            <div className={s.name}>{row.original.title}</div>
          </Tooltip>
        ),
        width: 424,
      },
      {
        Header: t('amount'),
        accessor: 'quantity',
        Cell: ({ value }) =>
          value < 0 ? '∞' : `${value.toLocaleString()} ${t('pcs')}`,
        width: 150,
      },
      {
        Header: t('cost'),
        accessor: 'cost',
        Cell: ({ value }) => `${value.toLocaleString()} ${currency.sign}`,
        width: 145,
      },
    ],
    [t]
  );
};
